import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  getApiClient,
  initializeApiClient,
} from "../../../Services/apiService";

export const GetStepsAction = createAsyncThunk(
  "GetStepsAction",
  async (taskFlowGUID, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post("api/StepsAction/GetStepsAction", {
        taskFlowGUID: taskFlowGUID,
      });

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "GetStepsAction");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const UpdateStepsAction = createAsyncThunk(
  "UpdateStepsAction",
  async (action, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post(
        "api/StepsAction/UpdateStepsAction",
        {
          wF_StepsActionGuid: action.wF_StepsActionGuid,
          statementReasons: action.statementReasons,
          actionType: action.actionType,
          taskFlowGUID: action.taskFlowGUID,
        }
      );

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "UpdateStepsAction");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

const StepsAction = createSlice({
  name: "StepsAction",
  initialState: {
    StepsAction: {},
    loadingStepsAction: false,
    errorStepsAction: null,

    //---------------------------------------------
    StepsActionUpdate: {},
    loadingStepsActionUpdate: false,
    errorStepsActionUpdate: null,
  },
  reducers: {

    SetStepsAction:(state,action)=>{
        state.StepsAction=action.payload
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(GetStepsAction.pending, (state, action) => {
        state.loadingStepsAction = true;
        state.StepsAction = action.payload;
        state.errorStepsAction = null;
      })
      .addCase(GetStepsAction.fulfilled, (state, action) => {
        state.loadingStepsAction = false;
        state.StepsAction = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetStepsAction.rejected, (state, action) => {
        state.loadingStepsAction = false;
        state.errorStepsAction = action.payload;
      });

    //------------------------update--------------------------------------------
    builder
      .addCase(UpdateStepsAction.pending, (state, action) => {
        state.loadingStepsActionUpdate = true;
        state.StepsActionUpdate = action.payload;
        state.errorStepsActionUpdate = null;
      })
      .addCase(UpdateStepsAction.fulfilled, (state, action) => {
        state.loadingStepsActionUpdate = false;
        state.StepsActionUpdate = action.payload; // Assuming payload has the desired data
      })
      .addCase(UpdateStepsAction.rejected, (state, action) => {
        state.loadingStepsActionUpdate = false;
        state.errorStepsActionUpdate = action.payload;
      });
  },
});
export const {SetStepsAction}=StepsAction.actions;

export default StepsAction.reducer;
